import React from 'react'
import { useTranslation } from '@sailor/i18n-web'
import styles from './index.module.less'
import HighlightText from '../HighlightText'
import SelectedSvg from '../Icons/SelectedSvg'
import logoWhite from '@/assets/images/logoWhite-11a297.png'
import { isEn } from '@/common/utils/i18nFuncs'

const Enterprise = () => {
  const { t } = useTranslation()

  const statistics = [
    {
      number: '30',
      description: t('ent_o_enterprise_cost_saving', '成本最多节省'),
      suffix: '%',
    },
    {
      number: '10,000',
      description: t('ent_o_enterprise_served_count', '已服务企业近'),
      suffix: !isEn ? t('ent_o_enterprise_unit', '家') : '',
    },
  ]

  const services = [
    {
      title: t('ent_o_enterprise_consultant', '企业服务专家顾问1对1交流'),
    },
    {
      title: t('ent_o_enterprise_solution', '企业数智能化解决方案定制'),
    },
    {
      title: t('ent_o_enterprise_report', '企业员工餐饮消费发展趋势分析报告'),
    },
    {
      title: t('ent_o_enterprise_digital_service', '企业专属数字化建设咨询服务'),
    },
  ]

  return (
    <div className={styles.container}>
      <img src={logoWhite} style={{ height: '6.6rem' }} alt="" />
      <div className={styles.titleWrapper}>
        <div>
          <span>{t('ent_o_title_provide_for_you1', '为您提供')}</span>
          {isEn() ? <span>&nbsp;</span> : ''}
          <span>
            {t('ent_o_title_one_stop_solution', '一站式员工美食津贴解决方案')}
          </span>
        </div>
      </div>

      <div className={styles.statisticsWrapper}>
        {statistics.map((item, index) => (
          <>
            <div className={styles.statisticItem}>
              <div className={styles.description}>
                {item.description}
              </div>
              <div className={styles.number}>
                <span>{item.number}</span>
                {item.suffix && <span className={styles.suffix}>{item.suffix}</span>}
              </div>
            </div>
            {index < statistics.length - 1 && <div className={styles.divider} />}
          </>
        ))}
      </div>

      <div className={styles.servicesWrapper}>
        <h3 className={styles.serviceTitle}>
          {t('ent_o_enterprise_complete_notice', '申请完成后您将获得:')}
        </h3>
        <div className={styles.serviceList}>
          {services.map(service => (
            <div className={styles.serviceItem}>
              <SelectedSvg className={styles.checkIcon} />
              <span>{service.title}</span>
            </div>
          ))}
        </div>
      </div>
    </div>
  )
}

export default Enterprise
